// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__UZLda","label":"Labeled_label__3phBT","divider":"Labeled_divider__1pO_A"};